import {useEffect, useState} from 'react'
import {isEloquaCampaign} from '../../schemas/contentful/contentTypes/eloquaCampaign'
import {isMarketoCampaign} from '../../schemas/contentful/contentTypes/marketoCampaign'

export type UseCampaignResult = {
  isEloqua: boolean
  isMarketo: boolean
  redirectUrl?: string
  cDLProgramName?: string
  sFDCLastCampaignStatus?: string
  source?: string
  directToSfdcCampaignId?: string
  elqFormName?: string
}

export function useCampaign(campaign: unknown): UseCampaignResult {
  const [redirectUrl, setRedirectUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    try {
      const {origin, pathname, search} = window.location
      const normalizedPathname = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
      // Build new URL: origin + normalizedPathname + '/confirmation' + search
      const confirmationUrl = `${origin}${normalizedPathname}/confirmation${search}`
      // Setting to a primitive + the effect doesn't depend on any external values. This is safe.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setRedirectUrl(confirmationUrl)
    } catch {
      setRedirectUrl(undefined)
    }
    return () => setRedirectUrl(undefined)
  }, [campaign])

  let cDLProgramName: string | undefined
  let sFDCLastCampaignStatus: string | undefined
  let source: string | undefined
  let directToSfdcCampaignId: string | undefined
  let elqFormName: string | undefined

  if (isMarketoCampaign(campaign)) {
    const campaignFields = campaign.fields
    cDLProgramName = campaignFields.cDLProgramName
    sFDCLastCampaignStatus = campaignFields.sFDCLastCampaignStatus
    source = campaignFields.source
    directToSfdcCampaignId = campaignFields.directToSfdcCampaignId
  }

  if (isEloquaCampaign(campaign)) {
    elqFormName = campaign.fields.elqFormName
    source = campaign.fields.source
  }

  return {
    isEloqua: isEloquaCampaign(campaign),
    isMarketo: isMarketoCampaign(campaign),
    redirectUrl,
    cDLProgramName,
    sFDCLastCampaignStatus,
    source,
    directToSfdcCampaignId,
    elqFormName,
  }
}
